import { generatePath, useHistory } from "react-router-dom";
import { RequirementDefinitionStatus } from "@wingspanhq/payments/dist/interfaces/requirement";
import {
  CreateRequirementTabSlug,
  ENGAGEMENT_REQUIREMENTS_CREATE_BY_TEMPLATE_FLOW_PATH,
  ENGAGEMENT_REQUIREMENTS_CREATE_BY_TEMPLATE_SELECT_PATH,
  ENGAGEMENT_REQUIREMENTS_CREATION_TAB_SLUGS,
  ENGAGEMENT_REQUIREMENTS_DETAILS_PATH,
  ENGAGEMENT_REQUIREMENTS_ROOT_PATH,
  ENGAGEMENT_REQUIREMENTS_TAB_SLUGS,
  RequirementsDefinitionsDashboardTabSlug
} from "./constants";

export const getSectionPathByRequirementStatus = (
  requirementStatus: RequirementDefinitionStatus
) => {
  const mapping: Record<
    RequirementDefinitionStatus,
    RequirementsDefinitionsDashboardTabSlug
  > = {
    [RequirementDefinitionStatus.Active]: "active",
    [RequirementDefinitionStatus.Inactive]: "archived"
  };

  const slug: RequirementsDefinitionsDashboardTabSlug =
    mapping[requirementStatus] || ENGAGEMENT_REQUIREMENTS_TAB_SLUGS[0];

  return `${ENGAGEMENT_REQUIREMENTS_ROOT_PATH}/${slug}`;
};

export const buildRequirementDetailsPath = (requirementId: string) => {
  return generatePath(ENGAGEMENT_REQUIREMENTS_DETAILS_PATH, {
    requirementId
  });
};

export const getCreateRequirementDefinitionPathname = (
  tab?: CreateRequirementTabSlug
) => {
  return generatePath(ENGAGEMENT_REQUIREMENTS_CREATE_BY_TEMPLATE_SELECT_PATH, {
    tabId: tab || ENGAGEMENT_REQUIREMENTS_CREATION_TAB_SLUGS[0]
  });
};

export const getCreateRequirementDefinitionFlowPathname = (
  templateId: string
) => {
  return generatePath(ENGAGEMENT_REQUIREMENTS_CREATE_BY_TEMPLATE_FLOW_PATH, {
    templateId
  });
};

export const useGoToRequirementDefinitions = () => {
  const history = useHistory();
  return (requirementStatus?: RequirementDefinitionStatus) => {
    history.push(
      getSectionPathByRequirementStatus(
        requirementStatus || RequirementDefinitionStatus.Active
      )
    );
  };
};

export const useGoToRequirementDefinitionDetails = () => {
  const history = useHistory();

  return (requirementId: string) => {
    history.push(buildRequirementDetailsPath(requirementId));
  };
};
